
import { TrustAPI } from "@/shared/modules/trust-api";
import { ComplianceForm, PartAFormTrustAccountDetails } from "@/shared/modules/typescript-trustapi-client/models";
import { AppInsights } from "@/trust-atcs-app/appInsights";
import { FormPartAData } from "@/trust-atcs-app/models/form-part-a-data";
import store from "@/trust-atcs-app/store";
import { EventEmitter } from "events";
import { Emit, Inject, Options, Prop, Vue, Watch } from "vue-property-decorator";
import RadioButtonHorizontal from "../questions/radiobutton-horizontal/index.vue";
import RadioButtonVertical from "../questions/radiobutton-vertical/index.vue";
import RadioButtonBranchList from "../questions/radiobutton-branchlist/index.vue";
import MultiRadioBoxes from "../questions/multi-radioboxes/index.vue";

@Options({
  components: {
    RadioButtonHorizontal,
    RadioButtonVertical,
    RadioButtonBranchList,
    MultiRadioBoxes
  }
})
export default class FormPartATrustAccountDetails extends Vue {
  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Prop()
  private formPartAData!: FormPartAData;

  @Prop({ default: false })
  private isSectionLoading!: boolean;

  @Emit('update:isSectionLoading')
  @Emit('validForm')

  @Watch('loadingContent')
  private sectionLoading() {
    this.$emit('update:isSectionLoading', this.loadingContent);
  }

  private ai = new AppInsights;
  private loadingContent = false;
  private errorLoadingContent = false;

  private trustAccountDetailsContent: PartAFormTrustAccountDetails = null as any;
  private validMainQuestions: boolean[] = [];

  created(): void {
    this.loadTrustAccountDetailsContent();
  }

  mounted(): void {
    this.eventCtrl.on('reload-form-a-tadetails-content', this.loadTrustAccountDetailsContent);
  }

  beforeUnmount(): void {
    this.eventCtrl.removeListener('reload-form-a-tadetails-content', this.loadTrustAccountDetailsContent);
  }

  private async loadTrustAccountDetailsContent(): Promise<void> {
    try {
      this.loadingContent = true;
      const resp: any = await this.apiService.PartAFormApi?.apiV2PartAFormGetTrustAccountDetailsPost({
        complianceFormId: this.complianceFormA.id,
        updatingKey: this.updatingKey,
      });

      this.trustAccountDetailsContent = resp.data.data as PartAFormTrustAccountDetails;
      this.formPartAData.trustAccountDetails = this.trustAccountDetailsContent;

      // Sort atcsMainQuestions by order number
      this.formPartAData.trustAccountDetails.atcsMainQuestions = this.formPartAData.trustAccountDetails.atcsMainQuestions.sort((a: any, b: any) => a.order - b.order);
      // Sort atcsSubQuestions by order number
      this.formPartAData.trustAccountDetails.atcsMainQuestions.forEach((q: any) => {
        q.atcsSubQuestions = q.atcsSubQuestions.sort((a: any, b: any) => a.order - b.order);
      });

      // Sort response by order number
      this.formPartAData.trustAccountDetails.atcsMainQuestions.forEach((q: any) => {
        q.responses = q.responses.sort((a: any, b: any) => a.order - b.order);
      });

      this.validMainQuestions = this.formPartAData.trustAccountDetails.atcsMainQuestions.map((q: any) => false);
    } catch (err) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error loading content');
      this.errorLoadingContent = true;
      console.log(err);
      this.ai.trackException('Error loading Trust Account Detail' + err);
    } finally {
      this.loadingContent = false;
    }
  }

  // private onValueChanged(event: any): void {
  //   this.$emit('validForm', this.validForm());
  // }

  private validForm(): boolean {
    return !this.validMainQuestions.includes(false);
  }

  private validationForm(i: any, isValid: any) {
    this.validMainQuestions[i] = isValid;
    this.$emit('validForm', this.validForm());
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  get complianceFormA(): ComplianceForm {
    return store.getters.getSelectedComplianceFormA;
  }

  get updatingKey(): string {
    return store.getters.getFormUpdatingKey;
  }
}

